module.exports = __webpack_public_path__ + "static/media/waitingroom_background.d3f0ac87.jpg";